/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Russell_TitleInputs */



/**

* @param {Home_Quotes_Russell_TitleInputs} inputs
* @param {{ locale?: "es" }} options
* @returns {LocalizedString}
*/
export const home_quotes_russell_title = /** @type {((inputs?: Home_Quotes_Russell_TitleInputs, options?: { locale?: "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Russell_TitleInputs, { locale?: "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Autor del manual de referencia sobre IA")
});